import React from "react";
import { Button, Modal, Form } from "antd";
import TextInput from "../../ReusableInputs/TextInput";

interface StoreDataProps {
  storeName: string;
  storeId: string;
  storeNo: string;
  streetAddress: string;
  city: string;
  state: string;
  zip: string;
  phoneNo: number;
  status: string;
  lat: number;
  lng: string;
  addressType: string;
  locationType: string;
  sellMachine: boolean;
  metaTitle: string;
  metaDescription: string;
  sellmachine: boolean;
  exchange: boolean;
  meta_title: string;
  meta_description: string;
  isUpdating: boolean;

  visible: boolean;
  onClose: () => void;
  isProcessing: boolean;
  isModalVisible: boolean;
  handleModalCancel: () => void;
  setStoreName: (value: string) => void;
  setExchange: (value: boolean) => void;
  setStoreId: (value: string) => void;
  setStoreNo: (value: string) => void;
  setStreetAddress: (value: string) => void;
  setCity: (value: string) => void;
  setState: (value: string) => void;
  setZip: (value: string) => void;
  setPhoneNo: (value: number) => void;
  setStatus: (value: string) => void;
  setLat: (value: number) => void;
  setLng: (value: string) => void;
  setAddressType: (value: string) => void;
  setLocationType: (value: string) => void;
  setSellMachine: (value: boolean) => void;
  setMetaTitle: (value: string) => void;
  setMetaDescription: (value: string) => void;
  handleFormSubmit: (value: any) => void;
  handleSaveEdit: (value: any) => void;
}

const StoreModal: React.FC<StoreDataProps> = ({
  visible,
  onClose,
  isProcessing,
  isModalVisible,

  // StoreDataProps values
  storeName,
  storeId,
  storeNo,
  streetAddress,
  city,
  state,
  zip,
  phoneNo,
  status,
  lat,
  lng,
  addressType,
  locationType,
  sellMachine,
  exchange,
  metaTitle,
  metaDescription,
  handleFormSubmit,

  setStoreName,
  setStoreId,
  setStoreNo,
  setStreetAddress,
  setCity,
  setState,
  setZip,
  setPhoneNo,
  setStatus,
  setLat,
  setLng,
  setAddressType,
  setLocationType,
  setSellMachine,
  setMetaTitle,
  setMetaDescription,
  handleSaveEdit,

  handleModalCancel,
  isUpdating,
}) => {
  const [form] = Form.useForm();

  return (
    <Modal
      title={isUpdating ? "Update Store" : "Add Store"}
      visible={isModalVisible}
      onCancel={handleModalCancel}
      footer={null}
      width={700}
      bodyStyle={{ maxHeight: "550px", overflowY: "auto" }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={() => {
          if (isUpdating) {
            handleSaveEdit({
              storeName,
              storeId,
              storeNo,
              streetAddress,
              city,
              state,
              zip,
              phoneNo,
              status,
              lat,
              lng,
              addressType,
              locationType,
              sell_machine: sellMachine,
              cylinder_exchange: exchange,
              meta_title: metaTitle,
              meta_description: metaDescription,
            });
          } else {
            handleFormSubmit({
              storeName,
              storeId,
              storeNo,
              streetAddress,
              city,
              state,
              zip,
              phoneNo,
              status,
              lat,
              lng,
              addressType,
              locationType,
              sell_machine: sellMachine,
              cylinder_exchange: exchange,
              meta_title: metaTitle,
              meta_description: metaDescription,
            });
          }
        }}>
        <section className="flex flex-col md:flex-row md:space-x-4">
          <div className="w-full p-2">
            <TextInput
              title="Store Name"
              placeholder="Enter the store name"
              inputValue={storeName}
              setInputValue={setStoreName}
            />
          </div>
          <div className="w-full p-2">
            <TextInput
              title="Store ID"
              placeholder="Enter the store ID"
              inputValue={storeId}
              setInputValue={setStoreId}
            />
          </div>
        </section>

        <section className="flex flex-col md:flex-row md:space-x-4">
          <div className="w-full p-2">
            <TextInput
              title="Store Number"
              placeholder="Enter the store number"
              inputValue={storeNo}
              setInputValue={setStoreNo}
            />
          </div>
          <div className="w-full p-2">
            <TextInput
              title="Street Address"
              placeholder="Enter street address"
              inputValue={streetAddress}
              setInputValue={setStreetAddress}
            />
          </div>
        </section>

        <section className="flex flex-col md:flex-row md:space-x-4">
          <div className="w-full p-2">
            <TextInput
              title="City"
              placeholder="Enter city"
              inputValue={city}
              setInputValue={setCity}
            />
          </div>
          <div className="w-full p-2">
            <TextInput
              title="State"
              placeholder="Enter state"
              inputValue={state}
              setInputValue={setState}
            />
          </div>
        </section>

        <section className="flex flex-col md:flex-row md:space-x-4">
          <div className="w-full p-2">
            <TextInput
              title="ZIP Code"
              placeholder="Enter ZIP code"
              inputValue={zip}
              setInputValue={setZip}
            />
          </div>
          <div className="w-full p-2">
            <TextInput
              title="Phone Number"
              placeholder="Enter phone number"
              inputValue={phoneNo.toString()}
              setInputValue={(value) => setPhoneNo(Number(value))}
            />
          </div>
        </section>

        <section className="flex flex-col md:flex-row md:space-x-4">
          <div className="w-full p-2">
            <TextInput
              title="Status"
              placeholder="Enter status"
              inputValue={status}
              setInputValue={setStatus}
            />
          </div>
          <div className="w-full p-2">
            <TextInput
              title="Latitude"
              placeholder="Enter latitude"
              inputValue={lat.toString()}
              setInputValue={(value) => setLat(Number(value))}
            />
          </div>
        </section>

        <section className="flex flex-col md:flex-row md:space-x-4">
          <div className="w-full p-2">
            <TextInput
              title="Longitude"
              placeholder="Enter longitude"
              inputValue={lng}
              setInputValue={setLng}
            />
          </div>
          <div className="w-full p-2">
            <TextInput
              title="Address Type"
              placeholder="Enter address type"
              inputValue={addressType}
              setInputValue={setAddressType}
            />
          </div>
        </section>

        <section className="flex flex-col md:flex-row md:space-x-4">
          <div className="w-full p-2">
            <TextInput
              title="Location Type"
              placeholder="Enter location type"
              inputValue={locationType}
              setInputValue={setLocationType}
            />
          </div>
          <div className="w-full p-2">
            <TextInput
              title="Meta Title"
              placeholder="Enter meta title"
              inputValue={metaTitle}
              setInputValue={setMetaTitle}
            />
          </div>
        </section>

        <section className="flex flex-col md:flex-row md:space-x-4">
          <div className="w-full p-2">
            <TextInput
              title="Meta Description"
              placeholder="Enter meta description"
              inputValue={metaDescription}
              setInputValue={setMetaDescription}
            />
          </div>
        </section>

        <Button
          htmlType="submit"
          className="bg-teal-800 w-full mt-[7px] text-white font-semibold py-2 px-4 border border-gray-400 rounded shadow hover:bg-white hover:text-teal-800"
          loading={isProcessing}>
          {isProcessing
            ? isUpdating
              ? "Updating..."
              : "Adding..."
            : isUpdating
            ? "Update Store"
            : "Add Store"}
        </Button>
      </Form>
    </Modal>
  );
};

export default StoreModal;
